export default __webpack_public_path__ + "static/media/logo.09581d4b.svg";